import { SnackbarKey, useSnackbar } from "notistack";
import { useEffect } from "react";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import { remove } from "../slices/snackbar";

let displayed: SnackbarKey[] = [];

function Snackbars() {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const enqueued = useAppSelector(state => state.snackbar.enqueued);

  useEffect(() => {
    enqueued.forEach(notification => {
      if (notification && !displayed.includes(notification.key)) {
        enqueueSnackbar(notification.message, notification.options);
        displayed = [...displayed, notification.key];
        dispatch(remove({ key: notification.key }));
      }
    });
  }, [enqueued, enqueueSnackbar]);

  return null;
}

export default Snackbars;
